import React, { useMemo } from "react";

import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { t } from "i18next";
import Functions from "../../../General/Functions";
import Select, {
    components,
} from "react-select";
import makeAnimated from 'react-select/animated';


import { USER_ROLE_LIST, USER_STATUS_LIST } from "../../../config/constants";



const UserForm = ({
    form,
    errors,
    roles,
    companies,
    onChange,
    onSubmit,
    isEdit = false,
    onRegeneratePassword,
    showPassword,
    setShowPassword,
}) => {
    const phoneCountries = useMemo(
        () => Functions.getPhoneCountries(),
        []
    );
    const countryOptions = useMemo(
        () =>
            phoneCountries.map(c => ({
                value: c.callingCode,
                labelString: `${c.label} (${c.callingCode})`, // string used for filtering
                label: (
                    <div className="d-flex align-items-center gap-2">
                        <img
                            src={`https://flagcdn.com/24x18/${c.iso.toLowerCase()}.png`}
                            alt={c.label}
                            width={24}
                            height={18}
                            loading="lazy"
                        />
                        <span>{c.label} ({c.callingCode})</span>
                    </div>
                )
            })),
        [phoneCountries]
    );

    const filterCountryOption = (option, inputValue) => {
        const search = inputValue.toLowerCase().replace(/\+/g, "");
        return option.data.labelString
            .toLowerCase()
            .replace(/\+/g, "")
            .includes(search);
    };

    const roleLabels = {
        OPERATOR: t("role_operator"),
        DEVICE_MANAGER: t("role_device_manager"),
        OPERATOR_CHECKIN: t("role_operator_checkin"),
        OPERATOR_SUPERVISOR: t("role_operator_supervisor"),
        SYSADMIN: t("role_sysadmin"),
        BOARDING_OPERATOR: t("role_boarding_operator"),

    };
    const CustomMultiValue = (props) => (
        <components.MultiValue {...props}>
            {props.data.label}
        </components.MultiValue>
    );
    const options = companies?.map((item) => ({
        value: item?.toString(),
        label: `${item}`
    }));

    const animatedComponents = makeAnimated({
        MultiValue: CustomMultiValue
    });

    const mappedCompanies = form?.companies?.map(c => ({
        value: c,
        label: c
    }));



    return (
        <Form onSubmit={onSubmit}>
            <Row>
                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Body>
                            <h5>{t("basic_information")}</h5>

                            <Form.Group className="mb-3">
                                <Form.Label>{t("firstName")}</Form.Label>
                                <Form.Control name="firstName" value={form.firstName} onChange={onChange} isInvalid={!!errors?.firstName}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.firstName}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>{t("lastName")}</Form.Label>
                                <Form.Control name="lastName" value={form.lastName} onChange={onChange} isInvalid={!!errors?.lastName}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.lastName}
                                </Form.Control.Feedback>
                            </Form.Group>

                            {/*<Form.Group className="mb-3">
                                <Form.Label>{t("company")}</Form.Label>
                                <Form.Select
                                    name="company"
                                    value={form.company}
                                    onChange={onChange}
                                    isInvalid={!!errors?.company}
                                >
                                    <option value="">
                                        {t("select")}
                                    </option>

                                    {companies?.map((company, index) => (
                                        <option key={index} value={company}>
                                            {company}
                                        </option>
                                    ))}
                                </Form.Select>

                                <Form.Control.Feedback type="invalid">
                                    {errors?.company}
                                </Form.Control.Feedback>
                            </Form.Group>*/}

                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label className="label-nowrap">{t("company")}</Form.Label>

                                {!isEdit && (
                                    <Select
                                        label="companies"
                                        isMulti
                                        isOptionDisabled={() =>
                                            form?.role === "BOARDING_OPERATOR" &&
                                            form?.companies.length >= 1 && !isEdit
                                        }
                                        placeholder={t("select_company")}
                                        options={options}
                                        components={animatedComponents}
                                        onChange={(options) =>
                                            onChange({
                                                target: {
                                                    name: "companies",
                                                    value: options,
                                                },
                                            })
                                        }
                                    />
                                )}
                                {
                                    isEdit && (
                                        <Select
                                            label="companies"
                                            isMulti
                                            isOptionDisabled={() =>
                                                form?.role === "BOARDING_OPERATOR" &&
                                                form?.companies.length >= 1 && !isEdit
                                            }
                                            placeholder={t("select_company")}
                                            value={mappedCompanies}
                                            options={options}
                                            components={animatedComponents}
                                            onChange={(options) =>
                                                onChange({
                                                    target: {
                                                        name: "companies",
                                                        value: options,
                                                    },
                                                })
                                            }
                                        />
                                    )
                                }
                                {errors?.companies && (
                                    <div className="invalid-feedback d-block">
                                        {errors.companies}
                                    </div>
                                )}


                            </Form.Group>


                            <Form.Group className="mb-3">
                                <Form.Label>{t("email")}</Form.Label>
                                <Form.Control name="email" value={form.email} onChange={onChange} isInvalid={!!errors?.email}
                                />
                                <Form.Control.Feedback type="invalid">
                                    {errors?.email}
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>{t("phone")}</Form.Label>

                                <div className="d-flex flex-column flex-md-row gap-2">
                                    <div className="flex-shrink-0 mb-2 mb-md-0" style={{ minWidth: 120, maxWidth: 220 }}>
                                        <Select
                                            options={countryOptions}
                                            styles={selectStyles}
                                            value={countryOptions.find(
                                                o => o.value === form.phoneCountryCode
                                            )}
                                            onChange={(selected) =>
                                                onChange({
                                                    target: {
                                                        name: "phoneCountryCode",
                                                        value: selected.value,
                                                    },
                                                })
                                            }
                                            isSearchable
                                            filterOption={filterCountryOption}

                                        />
                                    </div>

                                    <Form.Control
                                        name="phoneNumber"
                                        value={form.phoneNumber}
                                        onChange={onChange}
                                        placeholder="312 345 6789"
                                        type="tel"
                                        inputMode="numeric"
                                        className="flex-grow-1"
                                        isInvalid={!!errors?.phoneNumber}
                                    />
                                </div>

                                {errors?.phoneNumber && (
                                    <div className="invalid-feedback d-block">
                                        {errors.phoneNumber}
                                    </div>
                                )}
                            </Form.Group>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={6}>
                    <Card className="mb-4">
                        <Card.Body>
                            <h5>{t("account_information")}</h5>

                            <Form.Group className="mb-3">
                                <Form.Label>{t("username")}</Form.Label>
                                <Form.Control
                                    name="username"
                                    value={form.username}
                                    onChange={onChange}
                                    disabled={isEdit}
                                    readOnly
                                />
                            </Form.Group>



                            <Form.Group className="mb-3">
                                <Form.Label>{t("role")}</Form.Label>

                                <Form.Select
                                    name="role"
                                    value={form?.role}
                                    onChange={onChange}
                                    isInvalid={!!errors?.role}
                                >
                                    <option value="">{t("select_role")}</option>

                                    {roles.map((role) => (
                                        <option key={role?.id} value={role?.name}>
                                            {roleLabels[role?.name]}
                                        </option>
                                    ))}
                                </Form.Select>
                                {(errors?.companies && form?.companies?.length > 0) && (
                                    <div className="invalid-feedback d-block">
                                        {errors.companies}
                                    </div>
                                )}

                                <Form.Control.Feedback type="invalid">
                                    {errors?.role}
                                </Form.Control.Feedback>
                            </Form.Group>


                            <Form.Group className="mb-3">
                                <Form.Label>{t("status")}</Form.Label>

                                <Form.Select
                                    name="status"
                                    value={form.status}
                                    onChange={onChange}
                                    required
                                >
                                    <option value="">{t("select_status")}</option>

                                    {USER_STATUS_LIST.map(status => (
                                        <option key={status} value={status}>
                                            {t(`status_${status.toLowerCase()}`)}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                            {!isEdit && (
                                <Form.Group className="mb-3">
                                    <Form.Label>{t("password")}</Form.Label>

                                    <div className="d-flex flex-wrap gap-2 align-items-start">
                                        <Form.Control
                                            className="flex-grow-1"
                                            type={showPassword ? "text" : "password"}
                                            value={form.password}
                                            readOnly
                                        />


                                        <Button
                                            variant="outline-secondary"
                                            onClick={() =>
                                                onRegeneratePassword({ ...form, password: onRegeneratePassword })
                                            }
                                        >
                                            {t("regenerate")}
                                        </Button>

                                        <Button
                                            variant="outline-secondary"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? t("hide") : t("show")}
                                        </Button>
                                    </div>
                                    <Form.Text className="text-muted">
                                        {t("password_auto_generated")}
                                    </Form.Text>
                                </Form.Group>)}
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Form>
    );
};

export default UserForm;
const selectStyles = {
    control: (base) => ({
        ...base,
        minHeight: "38px",
        height: "38px",
        borderColor: "#ced4da",
        boxShadow: "none",
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 8px",
        height: "38px",
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "38px",
    }),
};

